// extracted by mini-css-extract-plugin
export default {"footerCardDescription":"MainFooterAbout_footerCardDescription__1+NhF","footerFollow":"MainFooterAbout_footerFollow__mhNkz"};